import { render, staticRenderFns } from "./StockItemSearch.vue?vue&type=template&id=162a3711&scoped=true&"
import script from "./StockItemSearch.vue?vue&type=script&lang=js&"
export * from "./StockItemSearch.vue?vue&type=script&lang=js&"
import style0 from "./StockItemSearch.vue?vue&type=style&index=0&id=162a3711&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a3711",
  null
  
)

export default component.exports